
{
  "download": "Download",
  "empty": "No PDF to display",
  "error": "Failed to load PDF"
}
